/**
 * @generated SignedSource<<a9d39b69c4126e1461410e115c3b5d66>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommentActionsWriteReactionsSummaryFragment$data = {
  readonly ari: string;
  readonly containerAri: string;
  readonly reactionsCount: number;
  readonly reactionsSummaryForEmoji: ReadonlyArray<{
    readonly count: number;
    readonly emojiId: string;
    readonly id: string;
    readonly reacted: boolean;
  } | null>;
  readonly " $fragmentType": "CommentActionsWriteReactionsSummaryFragment";
};
export type CommentActionsWriteReactionsSummaryFragment$key = {
  readonly " $data"?: CommentActionsWriteReactionsSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentActionsWriteReactionsSummaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentActionsWriteReactionsSummaryFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ],
  "type": "ReactionsSummaryResponse"
};

(node as any).hash = "ac7b970423a77e8bceb853bf1fae7a69";

export default node;
